export const CLIENT_SECRET = "7S8j12qSv9UhLTwoxhjWRP3VnWqec0KVTxjeVkUv";
export const CLIENT_ID = "a08b7bd4-df33-4295-a45c-693eb541182e";
export const BASE_URL = "https://superviseur-backend.satisworld.online/";
export const CDN_BASE_URL = "https://superviseur-backend.satisworld.online";

// export const BASE_URL = "https://jsonplaceholder.typicode.com/";